/**
 * Created by admin on 2017/9/16.
 */
{
    angular.module('interfaceModule')
        .controller('uploadImageController',uploadImageController);
    uploadImageController.$inject = ['$scope',"$q",'utils.constant','$state',
        'utils.uploadManager',"request.file",'$timeout','utils.currentUser',
        'utils.common','utils.uploadImageManager','requestHandler'];
    function uploadImageController($scope,$q,constant,$state,
                                   uploadManager,fileRequest,$timeout,currentUser,
                                   common,uploadImageManager,requestHandler) {
        let vm=this;
        let collect={
            'activate':activate,
            //'translate_img':translate_img,
            'userId':null,
            'img_type':0,
            'selectImgAmount':selectImgAmount,
            'initUploader':initUploader,
            'uploader':null,
            'u_image1':{},
            'u_image2':{},
            'u_image3':{},
            'u_image4':{},
            'u_image5':{},
            'u_image6':{},
            'u_image7':{},
            //'checkImgWidthHeight':checkImgWidthHeight,
            'setImage':setImage,
            'position':'left',//center left位置
            'scale':1,//大小 1原图 2填充
            'tran_rotate':0,//旋转角度 0 90
            'up_wh':[
                {
                    up_imgWidth:0,
                    up_imgHeight:0
                },{
                    up_imgWidth:0,
                    up_imgHeight:0
                },{
                    up_imgWidth:0,
                    up_imgHeight:0
                },{
                    up_imgWidth:0,
                    up_imgHeight:0
                },{
                    up_imgWidth:0,
                    up_imgHeight:0
                },{
                    up_imgWidth:0,
                    up_imgHeight:0
                },{
                    up_imgWidth:0,
                    up_imgHeight:0
                }
                ],//存储宽高
            'up_image':[{docid:null},{docid:null},{docid:null},{docid:null},{docid:null},{docid:null},{docid:null}],//图片数组
            'imgSetting':[
                {
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                },{
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                },{
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                },{
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                },{
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                },{
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                },{
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                }
            ],
            'submitImageInf':submitImageInf,
            'timer':null,
            'checkInterval':1000,
            'checkImageIsCompose':checkImageIsCompose,
            'checking':false,
            'isMaxSizing':[false,false,false,false,false,false,false],//是否超过最大分辨率 数组 true超过 false正常
        };
        vm.collect=collect;
        activate();

        function activate(){
            initUploader(1);
            requestHandler.simpleRequest(constant.action.getUserId).then(function (respone) {
                collect.userId=respone.data[0].loginuserid;
                console.log("当前登录用户id",collect.userId);
            })
        }
        /*function translate_img() {
            collect.rotate = collect.rotate +10;
            var rotates = collect.rotate+'deg'
            console.log(collect.rotate);
            $(".test_img").css("transform","rotate("+rotates+")");
        }*/
        function selectImgAmount(index) {
            console.log("选择图片模式：",index);
            $(".select_upload_type li").removeClass('active');
            $(".select_upload_type li").eq(index).addClass('active');
            $('.upload_img').css("display","none");
            collect.img_type = index;
            for(var i=0;i<7 ;i++){
                collect.up_image[i].docid = null;
                collect.imgSetting[i].position=1;
                collect.imgSetting[i].scale=1;
                collect.imgSetting[i].tran_rotate=1;
                collect.isMaxSizing[i]=false;
            }
        }
        function initUploader(index){
            console.log("储存的图信息：",collect.up_image);
            uploadImageManager.init();
            uploadImageManager.u_image = {};
            collect.uploader=uploadImageManager.uploader;
            /*switch (index){
             case 1:
             collect.u_image1=uploadImageManager.u_image;
             break;
             case 2:
             collect.u_image2=uploadImageManager.u_image;
             break;
             case 3:
             collect.u_image3=uploadImageManager.u_image;
             break;
             case 4:
             collect.u_image4=uploadImageManager.u_image;
             break;
             case 5:
             collect.u_image5=uploadImageManager.u_image;
             break;
             case 6:
             collect.u_image6=uploadImageManager.u_image;
             break;
             case 7:
             collect.u_image7=uploadImageManager.u_image;
             break;
             }*/
            let delegate={};
            delegate.onWhenAddingFileFailed = function(item , filter, options) {
                common.prompt('文件上传失败，请确认所传文件是否符合要求');
            };
            delegate.onAfterAddingFile = function(fileItem) {
                console.log('开始上传');
                if(!collect.checking){
                    collect.checking=true;
                    $('.waiting').addClass("active");
                }
                $(".loading"+index).addClass("active");
            };
            delegate.onSuccessItem = function(fileItem, response, status, headers) {
                $(".loading"+index).removeClass("active");
                collect.checking=false;
                $('.waiting').removeClass("active");

                var img_container = $(".upload_img"+index);
                img_container.css("display","block");
                var   img = $(".up_img"+index),
                    container_w = img_container.css("width").replace("px",""),
                    container_h = img_container.css("height").replace("px","");
                console.log("容器宽:",container_w);
                console.log("容器高:",container_h);

                collect.up_image[index-1] = uploadImageManager.u_image;
                /*if(container_w==388 || container_w==188){
                 collect.up_wh[index-1].up_imgWidth = uploadImageManager.u_image.imgWidth*0.4*2;
                 collect.up_wh[index-1].up_imgHeight = uploadImageManager.u_image.imgHeight*0.4*2;
                 }else if(container_w==154 || container_w==74){
                 collect.up_wh[index-1].up_imgWidth = uploadImageManager.u_image.imgWidth*0.4*0.8;
                 collect.up_wh[index-1].up_imgHeight = uploadImageManager.u_image.imgHeight*0.4*0.8;
                 }*/
                collect.up_wh[index-1].up_imgWidth = uploadImageManager.u_image.imgWidth;
                collect.up_wh[index-1].up_imgHeight = uploadImageManager.u_image.imgHeight;
                //console.log(typeof collect.up_wh[index-1].up_imgWidth);
                console.log('上传图片原图宽度width：',collect.up_wh[index-1].up_imgWidth);
                console.log('上传图片原图高度height：',collect.up_wh[index-1].up_imgHeight);
                if(collect.up_wh[index-1].up_imgWidth>6000 || collect.up_wh[index-1].up_imgHeight>6000){
                    collect.isMaxSizing[index-1] = true;
                    common.alert("图片分辨率不得大于6000");
                }else{
                    collect.isMaxSizing[index-1] = false;
                }
                img.attr("src",uploadImageManager.u_image.path);
                console.log(collect.up_image);
                var img_w = collect.up_wh[index-1].up_imgWidth,
                    img_h = collect.up_wh[index-1].up_imgHeight,
                    p_wh = img_w/img_h;
                console.log("宽高比：",p_wh);

                img.css({//初始化图片
                    "transform": "rotate(0deg)",
                    "top":"50%",
                    "left":"50%",
                });
                collect.imgSetting[index-1]={
                    "position":1,//1:居中 2:左上角
                    "scale":1,//大小 1:原图 2:拉伸
                    "tran_rotate":1//1:不旋转 2:旋转90度
                };

                if(img_w>=img_h && img_w>container_w){//宽>高>容宽
                    if(container_w/p_wh>container_h){//按比例来 高>容高
                        img.css({
                            "width": container_h*p_wh+"px",
                            "height":container_h+"px",
                            "margin-left":-(container_h*p_wh/2),
                            "margin-right":-(container_h*p_wh/2),
                            "margin-top":-(container_h/2),
                            "margin-bottom":-(container_h/2),
                        })
                    }else{
                        img.css({
                            "width": container_w+"px",
                            "height":container_w/p_wh+"px",
                            "margin-left":-(container_w/2),
                            "margin-right":-(container_w/2),
                            "margin-top":-(container_w/p_wh/2),
                            "margin-bottom":-(container_w/p_wh/2),
                        })
                    }
                }else if(img_w<img_h && img_h>container_h){//图宽>高 图高>容高
                    if(container_h*p_wh>container_w){//按比例时 宽度超出容宽
                        img.css({
                            "width": container_w+"px",
                            "height":container_w/p_wh+"px",
                            "margin-left":-(container_w/2),
                            "margin-right":-(container_w/2),
                            "margin-top":-(container_w/p_wh/2),
                            "margin-bottom":-(container_w/p_wh/2),
                        })
                    }else{
                        img.css({
                            "width": container_h*p_wh+"px",
                            "height":container_h+"px",
                            "margin-left":-(container_h*p_wh/2),
                            "margin-right":-(container_h*p_wh/2),
                            "margin-top":-(container_h/2),
                            "margin-bottom":-(container_h/2),
                        })
                    }
                }else if(img_w<img_h && img_h < container_h){//图高>宽 图高<容高
                    if(img_h*p_wh>=container_w){//按比例时 宽度超出容宽
                        img.css({
                            "width": container_w+"px",
                            "height":container_w/p_wh+"px",
                            "margin-left":-(container_w/2),
                            "margin-right":-(container_w/2),
                            "margin-top":-(container_w/p_wh/2),
                            "margin-bottom":-(container_w/p_wh/2),
                        })
                    }else{
                        img.css({
                            "width": img_h*p_wh+"px",
                            "height":img_h+"px",
                            "margin-left":-(img_h*p_wh/2),
                            "margin-right":-(img_h*p_wh/2),
                            "margin-top":-(img_h/2),
                            "margin-bottom":-(img_h/2),
                        })
                    }

                }else if(img_w>=img_h && img_h>container_h){//图片宽>高>容高
                    if(container_w/p_wh>container_h){//以容器宽来适应 填的图高>容高时
                        img.css({
                            "width": container_h*p_wh+"px",
                            "height":container_h+"px",
                            "margin-left":-(container_h*p_wh/2),
                            "margin-right":-(container_h*p_wh/2),
                            "margin-top":-(container_h/2),
                            "margin-bottom":-(container_h/2),
                        })
                    }else{
                        img.css({
                            "width": container_w+"px",
                            "height":container_w/p_wh+"px",
                            "margin-left":-(container_w/2),
                            "margin-right":-(container_w/2),
                            "margin-top":-(container_w/p_wh/2),
                            "margin-bottom":-(container_w/p_wh/2),
                        })
                    }

                }else if(img_w<=container_w && img_h<=container_h){
                    img.css({
                        "width": img_w+"px",
                        "height":img_h+"px",
                        "margin-left":-(img_w/2),
                        "margin-right":-(img_w/2),
                        "margin-top":-(img_h/2),
                        "margin-bottom":-(img_h/2),
                    })
                }

            };
            delegate.onErrorItem = function(fileItem, response, status, headers) {
                common.alert('文件上传失败');

            };
            delegate.onCompleteItem = function(fileItem, response, status, headers) {
                // console.info('onCompleteItem', fileItem, response, status, headers);
                console.log('结束上传');
            };
            //checkImgWidthHeight(uploadImageManager.u_image);
            /*uploadImageManager.callbackDelegateList.push(delegate);
             $scope.$on("$destroy", function(e) {
             uploadImageManager.callbackDelegateList
             .splice(uploadImageManager.callbackDelegateList.indexOf(delegate),1);
             delegate=null;
             })*/
            uploadImageManager.callbackDelegateList = delegate;
            $scope.$on("$destroy", function(e) {
                uploadImageManager.callbackDelegateList = null;
                delegate=null;
            })

        }
        function setImage(index,type) {
            if(collect.up_image[index-1].docid){
                console.log("图片设置：",collect.imgSetting);
                var target_img = $(".up_img"+index),
                    real_w = collect.up_wh[index-1].up_imgWidth,//图片真实宽度
                    real_h = collect.up_wh[index-1].up_imgHeight,//图片真实高度
                    img_w = parseFloat(target_img.css("width").replace("px","")),//当前图片在容器中宽度
                    img_h = parseFloat(target_img.css("height").replace("px","")),//当前图片在容器中高度
                    img_container = $(".upload_img"+index),
                    p_wh = real_w/real_h.toFixed(2),
                    imgSetting = collect.imgSetting[index-1],
                    container_w = parseFloat(img_container.css("width").replace("px","")),//容器宽
                    container_h = parseFloat(img_container.css("height").replace("px",""));//容器高
                if(type == 0){//居中
                    collect.imgSetting[index-1].position = 1;
                    if(imgSetting.rotate == 2){//如果为旋转90°居中

                    }
                    target_img.css({
                        "top":"50%",
                        "left":"50%",
                        "margin-left":-(img_w/2),
                        "margin-right":-(img_w/2),
                        "margin-top":-(img_h/2),
                        "margin-bottom":-(img_h/2),
                    })
                }else if(type == 1){//左上角
                    if(imgSetting.position == 1){
                        collect.imgSetting[index-1].position = 2;
                        target_img.css({
                            "top":"0",
                            "left":"0",
                            "margin":"0"
                        })
                        if(img_w>img_h && real_w>=container_h && imgSetting.tran_rotate == 2){
                            target_img.css({
                                "top":(img_w-img_h)/2+"px",
                                "left":-(img_w-img_h)/2+"px"
                            })
                        }else if(img_w<img_h && real_h>container_w && imgSetting.tran_rotate == 2){
                            //alert("高度很大，旋转90")
                            target_img.css({
                                "top":"0",
                                "left":"50%",
                                "margin-left":-(img_w/2)+"px",
                                "margin-right":-(img_w/2)+"px",
                                "margin-top":-(container_w-img_w)/2+"px",
                                "margin-bottom":-(container_w-img_w)/2+"px",
                            })
                        }
                    }
                }else if(type == 2){//原图
                    collect.imgSetting[index-1].scale =1;
                    collect.imgSetting[index-1].tran_rotate = 1;
                    collect.imgSetting[index-1].position = 2;
                    target_img.css({
                        "-webkit-transform":"rotate(0deg)",
                        "-moz-transform":"rotate(0deg)",
                        "-ms-transform":"rotate(0deg)",
                        "-o-transform":"rotate(0deg)",
                        "transform":"rotate(0deg)",
                        "top":0,
                        "left":0,
                        "margin":0,
                    });
                    if(img_w>=img_h && real_w>=container_w){//原图宽大于容器宽 且 宽大于高
                        //alert("图宽大于高，容器宽小于图宽")
                        if(container_w/p_wh>container_h){//多张图片时，容宽>容高 按宽高比 图高>容高
                            target_img.css({
                                "width": container_h*p_wh+"px",
                                "height":container_h+"px",
                                /*"margin-left":-(container_h*p_wh/2)+"px",
                                "margin-right":-(container_h*p_wh/2)+"px",
                                "margin-top":-(container_h/2)+"px",
                                "margin-bottom":-(container_h/2)+"px"*/
                            })
                        }else{
                            target_img.css({
                                "width": container_w+"px",
                                "height":container_w/p_wh+"px",
                                /*"margin-left":-(container_w/2)+"px",
                                "margin-right":-(container_w/2)+"px",
                                "margin-top":-(container_w/p_wh/2)+"px",
                                "margin-bottom":-(container_w/p_wh/2)+"px"*/
                            })
                        }
                    }else if(img_w<img_h && real_h>=container_h){//原图宽小于容器高 且 宽小于高
                        if(container_h*p_wh>container_w){
                            target_img.css({//按宽高比 图宽>
                                "width": container_w+"px",
                                "height":container_w/p_wh+"px",
                                /*"margin-left":-(container_w/2)+"px",
                                "margin-right":-(container_w/2)+"px",
                                "margin-top":-(container_w/p_wh/2)+"px",
                                "margin-bottom":-(container_w/p_wh/2)+"px"*/
                            })
                        }else{
                            target_img.css({
                                "width": container_h*p_wh+"px",
                                "height":container_h+"px",
                                /*"margin-left":-(container_h*p_wh/2)+"px",
                                "margin-right":-(container_h*p_wh/2)+"px",
                                "margin-top":-(container_h/2)+"px",
                                "margin-bottom":-(container_h/2)+"px"*/
                            })
                        }
                    }else if(real_w<=container_w && real_h<=container_h){//原图比容器小
                        //alert("图小于容器");
                        target_img.css({
                            "width": real_w+"px",
                            "height":real_h+"px",
                            /*"margin-left":-(real_w/2)+"px",
                            "margin-right":-(real_w/2)+"px",
                            "margin-top":-(real_h/2)+"px",
                            "margin-bottom":-(real_h/2)+"px"*/
                        })
                    }
                }else if(type == 3){//填充
                    collect.imgSetting[index-1].scale = 2;
                    console.log("容器高",container_h);
                    if(imgSetting.tran_rotate == 1){//角度为0时填充
                        if(img_w<container_w && img_h<container_h){//只有在图高<容高 & 图宽 <容宽
                            if(imgSetting.position==2){
                                target_img.css({
                                    "top":"0",
                                    "left":"0",
                                    "margin":"0"
                                })
                            }
                            if(img_w>=img_h){//图宽>=高
                                console.log("图宽>=高");
                                if(container_w/p_wh>container_h){//多张图片时，容宽>容高 按宽高比 图高>容高
                                    target_img.css({
                                        "width": container_h*p_wh+"px",
                                        "height":container_h+"px",
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_h*p_wh/2)+"px",
                                            "margin-right":-(container_h*p_wh/2)+"px",
                                            "margin-top":-(container_h/2)+"px",
                                            "margin-bottom":-(container_h/2)+"px"
                                        })
                                    }
                                }else{
                                    target_img.css({
                                        "width": container_w+"px",
                                        "height":container_w/p_wh+"px",
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_w/2)+"px",
                                            "margin-right":-(container_w/2)+"px",
                                            "margin-top":-(container_w/p_wh/2)+"px",
                                            "margin-bottom":-(container_w/p_wh/2)+"px"
                                        })
                                    }
                                }
                            }else if(img_w<img_h){//图宽<高
                                console.log("图宽<高");
                                console.log("填充高",container_h);
                                console.log("填充宽",container_h*p_wh);
                                if(container_h*p_wh>container_w){//如果按宽高比来放大，宽度>容器宽
                                    target_img.css({
                                        "width": container_w+"px",
                                        "height":container_w/p_wh+"px",
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_w/2)+"px",
                                            "margin-right":-(container_w/2)+"px",
                                            "margin-top":-(container_w/p_wh/2)+"px",
                                            "margin-bottom":-(container_w/p_wh/2)+"px"
                                        })
                                    }
                                }else{
                                    target_img.css({
                                        "width": container_h*p_wh+"px",
                                        "height":container_h+"px",
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_h*p_wh/2)+"px",
                                            "margin-right":-(container_h*p_wh/2)+"px",
                                            "margin-top":-(container_h/2)+"px",
                                            "margin-bottom":-(container_h/2)+"px"
                                        })
                                    }
                                }
                            }
                        }
                    }else if(imgSetting.tran_rotate == 2){//角度为90
                        if(img_w<container_h && img_h<container_w){//只有在图高<容宽 & 图宽<容高时 填充
                            if(imgSetting.position==2){
                                target_img.css({
                                    "top":"0",
                                    "left":"0",
                                    "margin":"0"
                                })
                            }else if(imgSetting.position==1){
                                target_img.css({
                                    "top":"50%",
                                    "left":"50%"
                                })
                            }
                            if(img_w>img_h) {//图宽>=高
                                if(container_h/p_wh>container_w){//按宽高比填充 图高>容器宽（旋转90°后）
                                    target_img.css({
                                        "width": container_w*p_wh+"px",
                                        "height":container_w+"px",
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_w*p_wh/2)+"px",
                                            "margin-right":-(container_w*p_wh/2)+"px",
                                            "margin-top":-(container_w/2)+"px",
                                            "margin-bottom":-(container_w/2)+"px"
                                        })
                                    }
                                }else{
                                    target_img.css({
                                        "width": container_h+"px",
                                        "height":container_h/p_wh+"px",
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_h/2)+"px",
                                            "margin-right":-(container_h/2)+"px",
                                            "margin-top":-(container_h/p_wh/2)+"px",
                                            "margin-bottom":-(container_h/p_wh/2)+"px"
                                        })
                                    }
                                }

                            }else if(img_w<=img_h){//图宽<高
                                if(container_w*p_wh>container_h){//多张图片时，容宽>容高 90°旋转填充
                                    target_img.css({
                                        "width": container_h+"px",
                                        "height":container_h/p_wh+"px"
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_h/2)+"px",
                                            "margin-right":-(container_h/2)+"px",
                                            "margin-top":-(container_h/p_wh/2)+"px",
                                            "margin-bottom":-(container_h/p_wh/2)+"px"
                                        })
                                    }
                                }else{
                                    target_img.css({
                                        "width": container_w*p_wh+"px",
                                        "height":container_w+"px"
                                    });
                                    if(imgSetting.position==1){
                                        target_img.css({
                                            "margin-left":-(container_w*p_wh/2)+"px",
                                            "margin-right":-(container_w*p_wh/2)+"px",
                                            "margin-top":-(container_w/2)+"px",
                                            "margin-bottom":-(container_w/2)+"px"
                                        })
                                    }
                                }

                            }
                        }
                    }
                }else if(type == 4){
                    if(imgSetting.tran_rotate == 2){
                        collect.imgSetting[index-1].tran_rotate =1;
                        if(imgSetting.position == 2){//左上角时
                            target_img.css({
                                "-webkit-transform":"rotate(0deg)",
                                "-moz-transform":"rotate(0deg)",
                                "-ms-transform":"rotate(0deg)",
                                "-o-transform":"rotate(0deg)",
                                "transform":"rotate(0deg)",
                                "margin":"0",
                                "top":"0",
                                "left":"0"
                            })
                            if(img_h>img_w && real_h>container_h){
                                target_img.css({
                                    "width":container_h*p_wh+"px",
                                    "height":container_h+"px"
                                })
                            }else if(img_w>img_h && real_w>container_w){
                                target_img.css({
                                    "width":container_w+"px",
                                    "height":container_w/p_wh+"px"
                                })
                            }
                        }else if(imgSetting.position == 1){//居中时
                            target_img.css({
                                "-webkit-transform":"rotate(0deg)",
                                "-moz-transform":"rotate(0deg)",
                                "-ms-transform":"rotate(0deg)",
                                "-o-transform":"rotate(0deg)",
                                "transform":"rotate(0deg)",
                                "top":"50%",
                                "left":"50%",
                                "margin-left":-(img_w/2)+"px",
                                "margin-right":-(img_w/2)+"px",
                                "margin-top":-(img_h/2)+"px",
                                "margin-bottom":-(img_h/2)+"px",
                            })
                            if(img_h>img_w && real_h>container_h){
                                target_img.css({
                                    "width":container_h*p_wh+"px",
                                    "height":container_h+"px",
                                    "margin-left":-(container_h*p_wh/2)+"px",
                                    "margin-right":-(container_h*p_wh/2)+"px",
                                    "margin-top":-(container_h/2)+"px",
                                    "margin-bottom":-(container_h/2)+"px"
                                })
                            }else if(img_w>img_h && real_w>container_w){
                                target_img.css({
                                    "width":container_w+"px",
                                    "height":container_w/p_wh+"px",
                                    "margin-left":-(container_w/2)+"px",
                                    "margin-right":-(container_w/2)+"px",
                                    "margin-top":-(container_w/p_wh/2)+"px",
                                    "margin-bottom":-(container_w/p_wh/2)+"px"
                                })
                            }
                        }
                    }

                }else if(type == 5) {
                    if (imgSetting.tran_rotate == 1) {
                        collect.imgSetting[index - 1].tran_rotate = 2;
                        //console.log("collect.tran_rotate:",collect.tran_rotate);
                        //target_img.css("transform", "rotate(-90deg");
                        target_img.css({
                            "-webkit-transform":"rotate(-90deg)",
                            "-moz-transform":"rotate(-90deg)",
                            "-ms-transform":"rotate(-90deg)",
                            "-o-transform":"rotate(-90deg)",
                            "transform":"rotate(-90deg)",
                        });
                        if (imgSetting.position == 1) {
                            target_img.css({
                                "margin-left": -(img_w / 2) + "px",
                                "margin-right": -(img_w / 2) + "px",
                                "margin-top": -(img_h / 2) + "px",
                                "margin-bottom": -(img_h / 2) + "px",
                            })
                        }
                        if (real_w > real_h && real_w > container_h) {//宽>高 宽大于容器高
                            if (container_h / p_wh > container_w) {//按比例撑 图高大于容宽
                                target_img.css({
                                    "width": container_w * p_wh + "px",
                                    "height": container_w + "px",
                                    "margin-top": (container_h - container_h / p_wh) / 2 + "px",
                                    "margin-left": -(container_h - container_h / p_wh) / 2 + "px",
                                });
                                if (imgSetting.position == 1) {
                                    target_img.css({
                                        "margin-left": -(container_w * p_wh / 2) + "px",
                                        "margin-right": -(container_w * p_wh / 2) + "px",
                                        "margin-top": -(container_w / 2) + "px",
                                        "margin-bottom": -(container_w / 2) + "px",
                                    })
                                }
                            } else {
                                target_img.css({
                                    "width": container_h + "px",
                                    "height": container_h / p_wh + "px",
                                    "margin-top": (container_h - container_h / p_wh) / 2 + "px",
                                    "margin-left": -(container_h - container_h / p_wh) / 2 + "px",
                                });
                                if (imgSetting.position == 1) {
                                    target_img.css({
                                        "margin-left": -(container_h / 2) + "px",
                                        "margin-right": -(container_h / 2) + "px",
                                        "margin-top": -(container_h / p_wh / 2) + "px",
                                        "margin-bottom": -(container_h / p_wh / 2) + "px",
                                    })
                                }
                            }

                        } else if (real_w < real_h && real_h > container_w) {//宽<高 高>容器宽
                            target_img.css({
                                "width": container_w * p_wh + "px",
                                "height": container_w + "px",
                                "margin-left": (container_w - container_w * p_wh) / 2 + "px",
                                "margin-top": -(container_w - container_w * p_wh) / 2 + "px"
                            });
                            if (imgSetting.position == 1) {
                                target_img.css({
                                    "margin-left": -(container_w * p_wh / 2) + "px",
                                    "margin-right": -(container_w * p_wh / 2) + "px",
                                    "margin-top": -(container_w / 2) + "px",
                                    "margin-bottom": -(container_w / 2) + "px",
                                })
                            }
                        } else if (real_w < container_w && real_h < container_w) {
                            target_img.css({
                                "width": img_w + "px",
                                "height": img_h + "px"
                            });
                            if (imgSetting.position == 1) {
                                target_img.css({
                                    "margin-left": -(img_w / 2) + "px",
                                    "margin-right": -(img_w / 2) + "px",
                                    "margin-top": -(img_h / 2) + "px",
                                    "margin-bottom": -(img_h / 2) + "px",
                                })
                            }
                        }
                    }
                }
            }else{
                common.alert("请先上传图片")
            }


        }
        function submitImageInf() {
            console.log("up_image",collect.up_image);
            let _data = {};
            if(collect.img_type == 0 && !collect.up_image[0].docid){
                common.alert("请先上传图片");
                return false;
            }else if(collect.img_type == 1 && (!collect.up_image[1].docid || !collect.up_image[2].docid) ){
                common.alert("请先上传两张图片");
                return false;
            }else if(collect.img_type == 2 && (!collect.up_image[3].docid || !collect.up_image[4].docid || !collect.up_image[5].docid || !collect.up_image[6].docid)){
                common.alert("请先上传四张图片");
                return false;
            }
            for(var i=0; i<collect.isMaxSizing.length;i++){
                if(collect.isMaxSizing[i]==true){
                    common.alert("存在图片分辨率大于6000px，请修改后上传");
                    return false;
                }
            }
            switch (collect.img_type){
                case 0:
                    _data = {
                        'userid': collect.userId,
                        'docid1':  collect.up_image[0].docid,
                        'docpos1':collect.imgSetting[0].position,
                        'docsize1':collect.imgSetting[0].scale,
                        'docang1':collect.imgSetting[0].tran_rotate
                    };
                    break;
                case 1:
                    _data = {
                        'userid': collect.userId,
                        'docid1':  collect.up_image[1].docid,
                        'docpos1':collect.imgSetting[1].position,
                        'docsize1':collect.imgSetting[1].scale,
                        'docang1':collect.imgSetting[1].tran_rotate,
                        'docid2':  collect.up_image[2].docid,
                        'docpos2':collect.imgSetting[2].position,
                        'docsize2':collect.imgSetting[2].scale,
                        'docang2':collect.imgSetting[2].tran_rotate
                    };
                    break;
                case 2:
                    _data = {
                        'userid': collect.userId,
                        'docid1':  collect.up_image[3].docid,
                        'docpos1':collect.imgSetting[3].position,
                        'docsize1':collect.imgSetting[3].scale,
                        'docang1':collect.imgSetting[3].tran_rotate,
                        'docid2':  collect.up_image[4].docid,
                        'docpos2':collect.imgSetting[4].position,
                        'docsize2':collect.imgSetting[4].scale,
                        'docang2':collect.imgSetting[4].tran_rotate,
                        'docid3':  collect.up_image[5].docid,
                        'docpos3':collect.imgSetting[5].position,
                        'docsize3':collect.imgSetting[5].scale,
                        'docang3':collect.imgSetting[5].tran_rotate,
                        'docid4':  collect.up_image[6].docid,
                        'docpos4':collect.imgSetting[6].position,
                        'docsize4':collect.imgSetting[6].scale,
                        'docang4':collect.imgSetting[6].tran_rotate,
                    };
            }
            console.log("_data:",_data);
            let paramsStr='imageinfo='+JSON.stringify([_data]);
            requestHandler.simpleRequest(constant.action.uploadimageinfoget, paramsStr,
                function(responce){
                    console.log("下单返回：",responce);
                    if(responce.data[0].result == 1){
                        collect.checking = true;
                        $('.waiting').addClass("active");
                        checkImageIsCompose();
                    }else{
                        common.alert("下单失败，请重试")
                    }
                }
            );
        }
        //检测图片是否已合成文件
        function checkImageIsCompose() {
            let locationUrl = window.location.href;
            let urlReg = /^\S+uploadImage$/;//地址是否以uploadImage结尾
            //console.log("当前地址：",window.location.href);
            if(urlReg.test(locationUrl) && collect.checking){
                requestHandler.simpleRequest(constant.action.uploadResult, '',
                    function(responce){
                        console.log("开始检测合成文件：",responce);
                        if(responce.data[0].result == 1){
                            $('.waiting').removeClass("active");
                            collect.checking = false;
                            console.log(uploadImageManager.currentFileItem.printType);
                            $state.go('main.printSettings',{'printType':uploadImageManager.currentFileItem.printType});
                        }else{
                            collect.timer = $timeout(collect.checkImageIsCompose,collect.checkInterval)
                        }
                    })
            }else {
                $('.waiting').removeClass("active");
            }
        }

    }

}